import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Form, Input, Select } from 'antd'
import { LockOutlined, UserOutlined } from '@ant-design/icons';

import { ORG_CODE, SYS_CODE } from '../../utils/contrains'

const Item = Form.Item
const Option = Select.Option

export default class UserModify extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    
        
    static propTypes = {
        user: PropTypes.object.isRequired,
        roles: PropTypes.array.isRequired,
        setForm: PropTypes.func.isRequired
    }

    fm = React.createRef();
    UNSAFE_componentWillMount() {
        this.props.setForm(this.fm)
    }

    render() {
        const { roles, user } = this.props
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 15 }
        }
        return (
            <div>
                <Form ref={this.fm}>
                    <Item label=" 系統代碼：" {...formItemLayout} style={{ marginBottom: 0 }} >
                        <Item
                            style={{ display: 'inline-block', width: 'calc(40% - 12px)' }}
                            name="universityCode"
                            initialValue={user.universityCode ? user.universityCode : ORG_CODE}
                        >
                            <Input placeholder="學校代碼" disabled />
                        </Item>
                        <span
                            style={{ display: 'inline-block', width: 'calc(10% - 12px)', lineHeight: '32px', textAlign: 'center' }}
                        >
                            -
                        </span>
                        <Item
                            style={{ display: 'inline-block', width: 'calc(42% - 12px)' }}
                            name="workDomainCode"
                            initialValue={user.roleAuthorityCode ? user.roleAuthorityCode : SYS_CODE}
                        >
                            <Input placeholder="系統代碼" disabled />
                        </Item>
                    </Item>
                    <Item
                        {...formItemLayout}
                        label="用戶名稱"
                        name="anonymous"
                        initialValue={user.anonymous}
                        rules={[
                            { required: true, whitespace: true, message: '必須輸入用戶名稱' },
                        ]}
                    >
                        <Input placeholder="用戶名稱" />
                    </Item>
                    <Item
                        {...formItemLayout}
                        label="帳號"
                        name="accountCode"
                        initialValue={user.accountCode}
                        rules={[
                            { required: true, whitespace: true, message: '必須輸入帳號' },
                            { min: 4, message: '不符合帳號長度(至少4個字元)' },
                            { pattern: /^[a-zA-Z0-9_]+$/, message: '僅接受英文及數字' }
                        ]}
                    >
                        <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="帳號" disabled={user.gidSysMember} />

                    </Item>
                    <Item
                        {...formItemLayout}
                        label="密碼"
                        name="unencryptedKey"
                        initialValue={user.unencryptedKey}
                        rules={[
                            { required: true, whitespace: true, message: '必須輸入密碼' },
                            { min: 8, message: '不符合帳號長度(至少8個字元)' },
                            { pattern: /^[a-zA-Z0-9_]+$/, message: '僅接受英文及數字' }
                        ]}
                    >
                        <Input
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            placeholder="密碼"
                        />
                    </Item>
                    <Item
                        {...formItemLayout}
                        label="角色分類"
                        name="roleAuthorityCode"
                        initialValue={user.roleAuthorityCode}
                        rules={[
                            {
                                required: true,
                            },
                        ]}
                    >
                        <Select placeholder="請選擇角色名稱">
                            {
                                roles.map(role => <Option key={role.roleCode} value={role.roleCode} >{role.roleName}</Option>)
                            }
                        </Select>
                    </Item>
                    <Item
                        {...formItemLayout}
                        label="註解"
                        name="recordRemarks"
                        initialValue='無'
                    >
                        <Input.TextArea placeholder="註解" />
                    </Item>
                    {
                        user.gidSysMember ? (
                            <Item
                                name="gidSysMember"
                                initialValue={user.gidSysMember}
                                hidden
                            >
                                <Input />
                            </Item>
                        ) : null
                    }
                    {
                        user.gidSysMember ? (
                            <Item
                                name="condition"
                                initialValue={user.condition}
                                hidden
                            >
                                <Input />
                            </Item>
                        ) : null
                    }
                </Form>
            </div>
        )
    }
}